export function PostPreviewSkeleton() {
  return (
    <div className="w-full max-w-2xl mx-auto bg-background">
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -1000px 0;
          }
          100% {
            background-position: 1000px 0;
          }
        }
        .skeleton-shimmer {
          background: linear-gradient(
            90deg,
            rgb(228, 228, 231) 0%,
            rgb(244, 244, 245) 50%,
            rgb(228, 228, 231) 100%
          );
          background-size: 1000px 100%;
          animation: shimmer 2s infinite;
        }
      `}</style>

      <div className="border rounded-lg overflow-hidden bg-card max-h-[600px] flex flex-col">
        {/* Header */}
        <div className="flex-shrink-0 px-6 py-3 border-b bg-background">
          <div className="flex items-center justify-between gap-3">
            {/* Tabs */}
            <div className="h-8 w-32 bg-muted rounded skeleton-shimmer"></div>

            {/* Actions */}
            <div className="flex items-center gap-2">
              <div className="h-8 w-20 bg-muted rounded skeleton-shimmer"></div>
              <div className="h-8 w-24 bg-muted rounded skeleton-shimmer"></div>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 px-4 bg-muted/60 overflow-hidden">
          <div className="flex h-full gap-3 py-4">
            {/* Preview Mode Toggle */}
            <div className="flex-shrink-0">
              <div className="flex flex-col gap-1 bg-secondary shadow-sm rounded-md p-1">
                <div className="w-10 h-10 bg-muted rounded skeleton-shimmer"></div>
                <div className="w-10 h-10 bg-muted rounded skeleton-shimmer"></div>
              </div>
            </div>

            {/* Preview Content */}
            <div className="flex-1 flex justify-center items-start overflow-hidden">
              <div className="w-full max-w-md">
                {/* Post preview placeholder */}
                <div className="bg-background rounded-lg border shadow-sm p-4 space-y-4">
                  {/* Header */}
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-muted rounded-full skeleton-shimmer"></div>
                    <div className="flex-1 space-y-2">
                      <div className="h-4 w-32 bg-muted rounded skeleton-shimmer"></div>
                      <div className="h-3 w-24 bg-muted rounded skeleton-shimmer"></div>
                    </div>
                  </div>

                  {/* Text content */}
                  <div className="space-y-2">
                    <div className="h-3 w-full bg-muted rounded skeleton-shimmer"></div>
                    <div className="h-3 w-5/6 bg-muted rounded skeleton-shimmer"></div>
                    <div className="h-3 w-4/6 bg-muted rounded skeleton-shimmer"></div>
                  </div>

                  {/* Image placeholder */}
                  <div className="aspect-square bg-muted rounded-lg skeleton-shimmer"></div>

                  {/* Actions */}
                  <div className="flex items-center gap-4 pt-2">
                    <div className="h-6 w-12 bg-muted rounded skeleton-shimmer"></div>
                    <div className="h-6 w-12 bg-muted rounded skeleton-shimmer"></div>
                    <div className="h-6 w-12 bg-muted rounded skeleton-shimmer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
